import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=5d6019ec&scoped=true"
import script from "./ScopeOfWork.vue?vue&type=script&lang=js"
export * from "./ScopeOfWork.vue?vue&type=script&lang=js"
import style0 from "./ScopeOfWork.vue?vue&type=style&index=0&id=5d6019ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6019ec",
  null
  
)

export default component.exports